export default function LegalPage() {
  return (
    <div style={{ maxWidth: '800px', padding: '0 20px', margin: '150px auto' }}>
      <h1>AUMHUM Legal Documents</h1>

      <ul>
        <li>
          <a href="terms">Terms of Service</a>
        </li>
        <li>
          <a href="privacy-policy-1">Privacy Policy</a>
        </li>
        <li>
          <a href="cookie-policy">Cookie Policy</a>
        </li>
        <li>
          <a href="#">Intellectual Property Guideline</a>
        </li>
        <li>
          <a href="instructor-terms">Instructor Terms of Service</a>
        </li>
        <li>
          <a href="copy-of-privacy-policy">Cancellation and Refund Policy</a>
        </li>
      </ul>
    </div>
  )
}
